import { render, staticRenderFns } from "./ClipBattles.vue?vue&type=template&id=238c0948&scoped=true&"
import script from "./ClipBattles.vue?vue&type=script&lang=js&"
export * from "./ClipBattles.vue?vue&type=script&lang=js&"
import style0 from "./ClipBattles.vue?vue&type=style&index=0&id=238c0948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c0948",
  null
  
)

export default component.exports